import React from 'react';
import { Award } from 'lucide-react';
export function ExpertEndorsement() {
  return <section className="py-16 px-4 md:px-8 lg:px-16 bg-gradient-to-r from-indigo-800 to-purple-800 text-white" data-id="element-18">
      <div className="max-w-7xl mx-auto" data-id="element-19">
        <div className="flex flex-col md:flex-row items-center" data-id="element-20">
          <div className="md:w-1/3 mb-8 md:mb-0 text-center" data-id="element-21">
            <img src="https://images.unsplash.com/photo-1560250097-0b93528c311a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80" alt="Dr. Alejandro Vega" className="w-48 h-48 rounded-full border-4 border-white object-cover mx-auto" data-id="element-22" />
            <h3 className="text-2xl font-bold mt-4" data-id="element-23">Dr. Alejandro Vega</h3>
            <p className="text-indigo-200" data-id="element-24">
              Experto en Frecuencias Vibratorias y Neurociencia
            </p>
          </div>
          <div className="md:w-2/3 md:pl-12" data-id="element-25">
            <div className="text-4xl font-serif text-indigo-200 mb-6" data-id="element-26">"</div>
            <p className="text-xl mb-6 italic" data-id="element-27">
              Después de 20 años investigando el impacto de las frecuencias en
              el cerebro humano, puedo afirmar que el programa 30 Días
              Frecuencia Prohibida utiliza las secuencias más potentes que he
              encontrado. Estas frecuencias específicas tienen la capacidad de
              reprogramar patrones neurológicos profundamente arraigados y
              elevar la vibración energética de forma permanente.
            </p>
            <p className="text-xl mb-8" data-id="element-28">
              Lo que hace único a este programa es la secuencia precisa de
              frecuencias y su combinación con prácticas que facilitan su
              integración. Los resultados que he observado en los participantes
              superan cualquier otro método que haya estudiado hasta la fecha.
            </p>
            <div className="flex flex-wrap gap-4" data-id="element-29">
              <div className="flex items-center bg-white/10 px-4 py-2 rounded-full" data-id="element-30">
                <Award size={20} className="mr-2" data-id="element-31" />
                <span data-id="element-32">PhD en Neurociencia</span>
              </div>
              <div className="flex items-center bg-white/10 px-4 py-2 rounded-full" data-id="element-33">
                <Award size={20} className="mr-2" data-id="element-34" />
                <span data-id="element-35">Autor de "Frecuencias del Cambio"</span>
              </div>
              <div className="flex items-center bg-white/10 px-4 py-2 rounded-full" data-id="element-36">
                <Award size={20} className="mr-2" data-id="element-37" />
                <span data-id="element-38">15+ Investigaciones Publicadas</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}